export default __webpack_public_path__ + "static/media/Team.bea057d1.svg";